/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

// Overview page components
import Header from "layouts/pages/profile/components/Header";
import PlatformSettings from "layouts/pages/profile/profile-overview/components/PlatformSettings";

// Data
import profilesListData from "layouts/pages/profile/profile-overview/data/profilesListData";

// Images
import logo from "assets/images/logo.svg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Alert(props) {
  return (
    <MDBox display="flex" justifyContent="space-between" alignItems="center" style={{backgroundColor: "red", padding: "15px", margin: "25px", borderRadius: "15px"}}>
      <MDBox >
        <MDTypography variant="p" fontWeight="heavy" style={{color: "white"}}>
          Sample Tool created by Aspen Tech Policy Hub Scholars, not the U.S. Department of Homeland Security
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

function Overview() {
  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <MDBox mb={2} />
      <Alert/>
      <Header>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={10} xl={8} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ProfileInfoCard
                title="public profile information"
                description="Hi, I’m Zoe Barnes, a fictitious Senior Advisor to the Director of U.S. Citizenship and Immigration Services (USCIS)"
                info={{
                  fullName: "Zoe Barnes",
                  mobile: "(716) 431- 7567",
                  email: "xxxxxxxx@uscis.dhs.gov",
                }}
                social={[
                  {
                    link: "https://twitter.com/",
                    icon: <TwitterIcon />,
                    color: "twitter",
                  },
                ]}
                action={{ route: "", tooltip: "Edit Profile" }}
                shadow={false}
              />
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>
            <Grid item xs={12} xl={4}>
              <ProfilesList title="recent applications" profiles={profilesListData} shadow={false} />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={2} px={2} style={{backgroundColor: "lightblue", borderRadius: "5px", margin: "25px", padding: "70px"}} lineHeight={1.25}>
          <MDBox mb={2}>
            <MDTypography fontWeight="medium">
              Proof of Concept
            </MDTypography>
          </MDBox>
          <MDBox mb={1}>
            <MDBox mb={2}>
              <MDTypography fontWeight="light">
                This tool is intended to prototype an automated application processor to help streamline USCIS's internal adjudication process. This mocks only one of the ways the tool can be implemented.
              </MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography fontWeight="light">
                This particular dashboard view is meant to represent what the
                <Link href={'https://www.uscis.gov/working-in-the-united-states/information-for-employers-and-employees/employer-information/validation-instrument-for-business-enterprises-vibe-program/'} target="_blank">
                  <MDTypography display="inline" fontWeight="medium">
                  {''} Validation Instrument for Business Enterprises (VIBE) {' '}
                  </MDTypography>
                </Link>
                dashboard might look like for adjudicators.
              </MDTypography>
            </MDBox>
            <MDTypography fontWeight="light">
              There are multiple key components of this prototype: first, the application 
              processor would dynamically parse information from a submitted 
              application; second, the application processor would be able to access 
              relevant databases such as 
              <Link href={'https://www.dnb.com/solutions/public-sector/verify-business-information.html'} target="_blank">
                  <MDTypography display="inline" fontWeight="medium">
                  {' '} Dun & Bradstreet {' '}
                  </MDTypography>
              </Link>
              and 
              <Link href={'https://www.crunchbase.com/'} target="_blank">
                <MDTypography display="inline" fontWeight="medium">
                {' '} Crunchbase
                </MDTypography>
              </Link>
              ; finally, 
              the processor should have the ability to dynamically compare the 
              submitted figures for startup entity and qualified investors against the 
              eligibility criteria.
            </MDTypography>
          </MDBox>
{/* 
          <MDBox mb={1}>
            <MDTypography  fontWeight="light" style={{display: "block", marginBottom: "5px"}} >
              <p>There are multiple key components of this prototype: </p>
              <p>First, the application processor would dynamically parse information from a submitted application</p>
              <p>Second, The application processor would be able to access relevant databases such as Dun & Bradstreet and CrunchBase.</p>
              <p>Finally, The ability to dynamically compare the submitted figures regarding the startup entity and qualified investors and the eligibility criteria.</p>
            </MDTypography>
          </MDBox> */}
        </MDBox>
        {/* <MDBox p={2}>
          <Grid container spacing={6}>
            <Grid item xs={12} md={6} xl={3}>
              <DefaultProjectCard
                image={logo}
                label="Priority 1"
                title="IEP"
                description="Under the International Entrepreneur Rule (IER), DHS may use its parole authority to grant a period of authorized stay, on a case-by-case basis, to foreign entrepreneurs who demonstrate that their stay in the United States would provide a significant public benefit through their business venture and that they merit a favorable exercise of discretion."
                action={{
                  type: "internal",
                  route: "/dashboards/iep-applications",
                  // route: "https://www.uscis.gov/humanitarian/humanitarian-parole/international-entrepreneur-parole",
                  color: "info",
                  label: "view project",
                }}
                authors={[
                  { image: team4, name: "Peterson" },
                  { image: team3, name: "Nikola Daniel" },
                  { image: team2, name: "Ryanne Castro" },
                  { image: team1, name: "Elena Morran" },
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <DefaultProjectCard
                image={logo}
                title="O-1 Visa"
                label="Priority 2"
                description="The O-1 nonimmigrant visa is for the individual who possesses extraordinary ability in the sciences, arts, education, business, or athletics, or who has a demonstrated record of extraordinary achievement in the motion picture or television industry and has been recognized nationally or internationally for those achievements."
                action={{
                  type: "external",
                  route: "https://www.uscis.gov/working-in-the-united-states/temporary-workers/o-1-visa-individuals-with-extraordinary-ability-or-achievement",
                  color: "info",
                  label: "view project",
                }}
                authors={[
                  { image: team3, name: "Nick Daniel" },
                  { image: team4, name: "Peterson" },
                  { image: team1, name: "Elena Morison" },
                  { image: team2, name: "Ryan Milly" },
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
            <DefaultProjectCard
                image={logo}
                title="EB-5 Visa"
                label="Priority 3"
                description="USCIS administers the EB-5 Immigrant Investor Program, created by Congress in 1990 to stimulate the U.S. economy through job creation and capital investment by foreign investors."
                action={{
                  type: "external",
                  route: "https://www.uscis.gov/working-in-the-united-states/permanent-workers/employment-based-immigration-fifth-preference-eb-5/about-the-eb-5-visa-classification",
                  color: "info",
                  label: "view project",
                }}
                authors={[
                  { image: team1, name: "Elena Morison" },
                  { image: team2, name: "Ryan Milly" },
                  { image: team3, name: "Nick Daniel" },
                  { image: team4, name: "Peterson" },
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6} xl={3}>
              <DefaultProjectCard
                image={logo}
                label="Priority 4"
                title="H1-B Visa"
                description="This nonimmigrant classification applies to people who wish to perform services in a specialty occupation, services of exceptional merit and ability relating to a Department of Defense (DOD) cooperative research and development project, or services as a fashion model of distinguished merit or ability."
                action={{
                  type: "external",
                  route: "https://www.uscis.gov/working-in-the-united-states/h-1b-specialty-occupations",
                  color: "info",
                  label: "view project",
                }}
                authors={[
                  { image: team4, name: "Peterson" },
                  { image: team3, name: "Nick Daniel" },
                  { image: team2, name: "Ryan Milly" },
                  { image: team1, name: "Elena Morison" },
                ]}
              />
            </Grid>
          </Grid>
        </MDBox> */}
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
